import { render, staticRenderFns } from "./WaveformPlayer.vue?vue&type=template&id=4f29d36c&scoped=true&"
import script from "./WaveformPlayer.vue?vue&type=script&lang=js&"
export * from "./WaveformPlayer.vue?vue&type=script&lang=js&"
import style0 from "./WaveformPlayer.vue?vue&type=style&index=0&id=4f29d36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f29d36c",
  null
  
)

export default component.exports